import React, { PureComponent } from 'react';
import { Icon } from 'react-fa';

class SocialButtons extends PureComponent {

  render() {
    const { follow } = this.props;
    return (
      <ul className="list-inline social-buttons">
        {
          follow.map((followObj, index)=> {
            return (
              <li key={index}><a target="_blank" href={followObj.contact}><Icon name={followObj.contact_type}/></a></li>
            );
          })
        }
      </ul>
    );
  }
}

SocialButtons.propTypes = {};
SocialButtons.defaultProps = {};

export default SocialButtons;



// WEBPACK FOOTER //
// ./src/components/SocialButtons/SocialButtons.js